module.exports = hiddenStore;

function hiddenStore(obj, key) {
    var store = { identity: key };
    var valueOf = obj.valueOf;

    Object.defineProperty(obj, "valueOf", {
        value: function (value) {
            return value !== key ?
                valueOf.apply(this, arguments) : store;
        },
        writable: true
    });

    return store;
}



//////////////////
// WEBPACK FOOTER
// ./~/weakmap-shim/hidden-store.js
// module id = 204
// module chunks = 0